// Email field validator

export default ({ mandatory = false, customError = null }) => {
  return {
    email: customError ? { message: customError } : true,
    presence: mandatory && { message: customError }
  };
};
